import { AxiosProvider } from '@nexelem/utils';
import { QueryClientProvider } from '@tanstack/react-query';
import { PropsWithChildren, Suspense } from 'react';
import { CommonLoader } from '../components/atoms/CommonLoader';
import { AuthProvider } from './AuthProvider';
import { ConfigProvider } from './ConfigProvider';
import { DateFNSConfigProvider } from './DateFNSConfigProvider';
import { I18nextProvider } from './I18nextProvider';
import { ReactQueryDevToolProvider } from './ReactQueryDevToolProvider';
import { ThemeProvider } from './ThemeProvider';
import { CustomToastProvider } from './ToastsProvider';
import { queryClient } from '../services/queryClient';
import { FaroProvider } from '@nexelem/grafana';

export const CommonProviders = ({ children }: PropsWithChildren) => (
  <AxiosProvider>
    <QueryClientProvider client={queryClient}>
      <FaroProvider>
        <ConfigProvider>
          <ThemeProvider>
            <AuthProvider>
              <I18nextProvider>
                <DateFNSConfigProvider>
                  <Suspense fallback={<CommonLoader />}>{children}</Suspense>
                  <CustomToastProvider />
                </DateFNSConfigProvider>
              </I18nextProvider>
            </AuthProvider>
          </ThemeProvider>
        </ConfigProvider>
        <ReactQueryDevToolProvider />
      </FaroProvider>
    </QueryClientProvider>
  </AxiosProvider>
);
